import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const AppLabel = styled((props: any) => (
  <Typography
    variant="subtitle1"
    fontWeight={300}
    color={props.color}
    {...props}
    component="label"
    htmlFor={props.htmlFor}
  />
))(() => ({
  marginBottom: "5px",
  marginTop: "10px",
  display: "block",
}));

export default AppLabel;
